
  import Vue, {PropType} from "vue";
  import {Wheel, ItemProps} from 'spin-wheel/dist/spin-wheel-esm.js';

  export default Vue.extend({
    name: "pwa-roulette",
    data() {
      return {
        wheel: null as Wheel,
      };
    },
    props: {
      items: {
        type: Array as PropType<ItemProps[]>,
        required: false,
        default: null,
      },
    },
    mounted(): void {
      this.initRoulette();
    },
    methods: {
      async initRoulette() {
        const computedStyle = window.getComputedStyle(document.documentElement);
        const lineColor = computedStyle.getPropertyValue('--primary');
        const itemLabelColor = computedStyle.getPropertyValue('--primary-text-color');
        const itemLabelFont = computedStyle.getPropertyValue('--font-family-title');

        const rouletteContainer = this.$refs.rouletteContainer as HTMLElement;
        const overlayImage = new Image();
        overlayImage.src = this.getBrandImageSrc('roulette/roulette-overlay4.png');
        try {
          await overlayImage.decode();
        } catch (e) {/** Nothing to do */}
        this.wheel = new Wheel(rouletteContainer, {
          // debug: true,
          items: this.items,
          itemLabelRadiusMax: 0.5,
          isInteractive: false,
          // image: getBrandImageSrc('roulette/roulette-center-image.png'),
          overlayImage,
          radius: 1,
          itemBackgroundColors: [],
          itemLabelColors: [itemLabelColor],
          lineWidth: 1,
          lineColor,
          itemLabelFont,
          itemLabelFontSizeMax: 45,
          itemLabelAlign: 'center',
          itemLabelRotation: 90,
          itemLabelBaselineOffset: -0.8,
        });
      },
      spinToItem(itemIndex: number, duration: number, spinToCenter: boolean, numberOfRevolutions: number): Promise<boolean> {
        return new Promise<boolean>((resolve => {
          this.wheel.rotationResistance = -35;
          this.wheel.spinToItem(itemIndex, duration, spinToCenter, numberOfRevolutions);
          this.wheel.onRest = () => {
            this.wheel.onRest = null;
            resolve(true);
          };
        }));
      },
      spin() {
        this.wheel.rotationResistance = 0;
        this.wheel.spin(200);
      },
      stop() {
        this.wheel.stop();
      },
    },
    watch: {
      items() {
        this.wheel.items = this.items;
      }
    },
  });
